import React, { useState } from 'react';
import axios from 'axios';

export default function AddReferenceModal({ onClose, refreshData }) {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return alert("Wybierz plik!");

    const formData = new FormData();
    formData.append('referenceImage', file);

    setLoading(true);
    try {
      await axios.post('https://megamont.pl/api/references', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      refreshData();
      onClose();
    } catch (err) {
      console.error("Błąd wysyłania pliku:", err);
      alert("Błąd podczas wgrywania referencji.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '450px' }}>
        <button type="button" className="modal-close-button" onClick={onClose}>&times;</button>
        <h2 className="mb-4">Dodaj Referencję</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group text-center">
            <label className="fw-bold mb-3 d-block">Wybierz plik graficzny (JPG, PNG)</label>
            
            {preview && (
              <div className="mb-3">
                <img src={preview} alt="Podgląd" className="img-thumbnail" style={{ maxHeight: '200px' }} />
              </div>
            )}

            <input 
              type="file" 
              className="form-control" 
              accept="image/*" 
              onChange={handleFileChange}
              required 
            />
          </div>

          <div className="modal-actions mt-4">
            <button type="submit" className="btn btn-primary w-100" disabled={loading}>
              {loading ? "Wgrywanie..." : "Wgraj Referencję"}
            </button>
            <button type="button" className="btn btn-secondary w-100" onClick={onClose}>Anuluj</button>
          </div>
        </form>
      </div>
    </div>
  );
}